export default __webpack_public_path__ + "static/media/check.6ad1153d.svg";